import { Tabs as d, tabsClasses as a, tabClasses as e, Tab as l, TabScrollButton as c, buttonClasses as $, CircularProgress as p } from "@mui/material";
import { styled as i, css as n } from "./styled2.mjs";
const g = i(d)`
	.${a.indicator} {
		border-radius: 10000px;
	}

	${({ $orientation: t, $style: r }) => t === "vertical" ? n`
				&.${a.root} {
					border-bottom: none;
					min-height: unset;
				}
				.${a.flexContainer} {
					gap: ${({ theme: o }) => o.spacing(1)};
				}
			` : n`
			&.${a.root} {
				min-height: ${({ theme: o }) => r !== "text" ? o.spacing(3) : o.spacing(4)};
			}
			.${a.scroller} {
				min-height: ${({ theme: o }) => r !== "text" ? o.spacing(3) : o.spacing(4)};
			}
		`};

	${({ $style: t, theme: r, $orientation: o }) => {
  const s = () => t === "containedRound" ? o === "horizontal" ? r.tokens.radius[40] : r.tokens.radius[16] : r.tokens.radius[8];
  if (t !== "text")
    return n`
				background: ${r.palette.grey[200]};
				padding: ${r.tokens.spacing[4]};
				border-radius: ${s()};

				.${a.indicator} {
					display: none;
				}
			`;
}};

	${({ $style: t, $orientation: r }) => {
  if (!(t === "text" || r === "vertical"))
    return n`
			&.${a.root} {
				border-bottom: none;
			}

			.${a.flexContainer} {
				gap: ${({ theme: o }) => o.spacing(1)};
			}
		`;
}};

	${({ $style: t, $orientation: r }) => {
  if (t !== "text" && r === "vertical")
    return n`
				.${e.root} {
					max-width: 100%;
				}
			`;
}};
`, x = i(l)`
	min-height: ${({ theme: t, $style: r }) => r !== "text" ? t.spacing(3.5) : t.spacing(4.5)};

	padding-block: 0;

	font-size: ${({ theme: t }) => t.spacing(1.75)};

	${({ theme: t }) => n`
			&.${e.disabled} {
				background: transparent;
				color: ${t.palette.text.disabled};
			}
		`};

	${({ $style: t, theme: r }) => {
  if (t !== "text")
    return n`
			&.${e.root} {
				color: ${r.palette.text.body};
				border-radius: ${t === "contained" ? r.tokens.radius[4] : r.tokens.radius[16]};
			}
			&.${e.selected} {
				background-color: ${r.palette.background.level3};
				box-shadow: ${r.tokens.shadow.small};
			}
			&.${e.disabled} {
				border: none;
				color: ${r.palette.text.disabled};
				cursor: not-allowed;
			}
		`;
}};
`, f = i(c)`
	opacity: 0.8;

	&.${$.disabled} {
		opacity: 0.2;
	}
`, k = i("div")`
	display: flex;
	align-items: center;
	gap: ${({ theme: t }) => t.spacing(1)};
`, y = i(p)`
	color: ${({ theme: t, $active: r }) => r ? t.palette.primary.main : t.palette.text.secondary};
`;
export {
  f as ScrollButton,
  x as StyledTab,
  k as StyledTabLabel,
  y as StyledTabLoader,
  g as StyledTabs
};
//# sourceMappingURL=styles18.mjs.map
